import { Blogs } from "../../../../../components/backgrounds/Blogs";

export function ComoConstruirPage() {
  return (
    <>
      <Blogs
        title={"Cómo construir historial crediticio"}
        content={
          <>
            <div className="pt-6 opacity-60 text-xl">
              <p className="">
                Tener un buen historial crediticio te permite obtener diferentes
                servicios con entidades financieras, por eso en este blog te
                contamos cómo puedes comenzar a construirlo.
              </p>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Hola Astronauta, si aún no has comenzado a crear tu historial
                crediticio y no sabes cómo iniciar, este artículo lo creamos
                especialmente para ti. Tener un buen puntaje crediticio es un
                factor fundamental que tienen en cuenta las entidades
                financieras antes de otorgar uno de sus servicios, por eso lo
                primero que tienes que conocer es si estás reportado en
                Datacrédito.
              </p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">
                Acerca de Datacrédito...
              </span>
            </div>
            <div className="pt-10 pb-10 opacity-60 text-xl">
              <p className="">
                Datacrédito es un ‘banco’ de datos que se encarga de recopilar y
                suministrar el comportamiento crediticio de todos los
                colombianos. Es un reflejo del comportamiento que has tenido con
                tus obligaciones y responsabilidades financieras que se van
                guardando hasta construir una historia de tus créditos, por eso,
                este historial funciona como un filtro a la hora de acceder a
                cualquier tipo de servicio financiero. Así que como astronauta,
                debes tener un buen puntaje e historial para que tus solicitudes
                sean aprobadas.
              </p>
            </div>
            <span className="text-xl lg:text-2xl font-light">
              <a href="/registrarse" className="text-purple hover:underline">
                Si quieres iniciar tu historial crediticio con Galilea haz clic
                aquí.
              </a>
            </span>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">
                Pasos para construir tu historial crediticio exitoso:
              </span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <ul role="list" className="pl-6 pt-6 list-decimal">
                <li>
                  Inicia temprano: En tu historial se tendrá en cuenta la
                  extensión del mismo, por eso debes iniciar lo más pronto
                  posible para que con el tiempo y un buen comportamiento de
                  pago puedas acceder a diversos productos financieros.
                </li>
                <li>
                  Contrata un plan de celular a tu nombre: Una forma fácil de
                  comenzar a crear tu historial es abriendo un plan a tu nombre,
                  al contratar este servicio y realizar un pago eficiente del
                  mismo comienzas a demostrar tu nivel de responsabilidad
                  financiera.
                </li>
                <li>
                  Paga tus obligaciones a tiempo: Todas tus deudas sin pagar
                  aparecen en el informe crediticio, esto impactará
                  negativamente en tu puntaje.
                </li>
                <li>
                  Abre una cuenta bancaria: Las cuentas bancarias de ahorro o de
                  nómina, te permiten iniciar un historial.
                </li>
                <li>
                  Solicita tu crédito en Galilea: Al solicitar un crédito en
                  Galilea te ayudamos a crear historial ya que nuestra misión
                  con nuestros créditos es darte experiencia crediticia, si
                  cumples con algunos requisitos básicos te daremos un crédito
                  acordé a tus capacidades de pago, que si líquidas de manera
                  adecuada nosotros lo anexamos a tu historial crediticio.
                </li>
              </ul>
            </div>           
          </>
        }
        enlace1={
          <a
            href="/blog/como-mejorar-mi-puntaje-en-datacredito"
            className="text-purple hover:underline"
          >
            ¿Cómo mejorar mi puntaje de crédito?
          </a>
        }
        enlace2={
          <a href="/blog/6-consejos-para-manejar-tus-finanzas" className="text-purple hover:underline">
            6 consejos para manejar tus finanzas
          </a>
        }
        enlace3={
          <a href="/blog/4-apps-para-llevar-un-registro-financiero" className="text-purple hover:underline">
            4 apps para llevar un registro financiero
          </a>
        }
      />
    </>
  );
}
